function toFlatAsyncMultiValuedListMoreItem({ item, t, valuePrefixTextKey }) {
  return {
    children: valuePrefixTextKey
      ? `${t(valuePrefixTextKey)} ${item.number}`
      : item.number,
    description: item.building?.title,
  }
}

export function getDataItems({ response, t, valuePrefixTextKey }) {
  return response.data.items.map(item =>
    toFlatAsyncMultiValuedListMoreItem({ item, t, valuePrefixTextKey })
  )
}
